// @flow

import React from 'react';
import { Bar } from 'react-chartjs-2';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Unstable_Grid2';
import { formatToIndianSystem } from 'utils/formatToIndianSystem';

function totalRequest({ records, title, duration, colorCode, yAxis }) {
  return (
    <Box>
      <Card>
        <CardContent>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            {title}
            <Chip label={duration} style={{ float: 'right' }} />
          </Typography>
          <Grid container>
            <Bar
              data={{
                labels: records && records.date.map((date) => new Date(date).toLocaleDateString('en-US', { weekday: 'long' })),
                datasets: [
                  {
                    label: title,
                    data: records && records.data,
                    backgroundColor: colorCode,
                  },
                ],
              }}
              options={{
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  x: {
                    stacked: true,
                  },
                  y: {
                    stacked: true,
                    max: yAxis.max,
                    ticks: {
                      stepSize: yAxis.stepSize, // Gap of 4 million
                      callback(value) {
                        return formatToIndianSystem(value);
                      },
                    },
                    grid: {
                      display: true,
                    },
                  },
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      label(context) {
                        return `${context.dataset.label}: ${formatToIndianSystem(context.raw)}`;
                      },
                    },
                  },
                },
              }}
            />
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}

export default totalRequest;
